import CreateEquipmentKitAssociation from "./CreateEquipmentKitAssociation";
import EditEquipmentKitAssociation from "./EditEquipmentKitAssociation";
import DeleteConfirmation from "./DeleteConfirmation";
import WatchEquipmentKit from "./WatchEquipmentKit";
import ManageEquipmentKits from "./ManageEquipmentKits";

const Dialogs = {
  CreateEquipmentKitAssociation,
  EditEquipmentKitAssociation,
  DeleteConfirmation,
  WatchEquipmentKit,
  ManageEquipmentKits,
}

export default Dialogs;